<div [ngClass]="corTitulo" class="container-fluid">
    <div class="container titulo pt-2 pb-1 pl-0" [ngClass]="tamanhoColuna">
        <svg width="46.476" height="19.951" viewBox="0 0 46.476 19.951"><path  [ngClass]="corTituloSvg" d="M286.477,6512.637l-23.261,19.951L240,6512.637Z" transform="translate(-240 -6512.637)"/></svg>
        <h4>{{tituloPaginas}}</h4>
    </div>
</div>
